// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__pwjBG","error":"Alert_error__EMWxY","warning":"Alert_warning__QKqZn"};